import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/order-logs';

class orderLogService {

    /**
     * Pobiera dane logów zamowienia na podstawie identyfikatora zamówienia (ID).
     * 
     * @param {number|string} id - ID zamówenia, którego chcemy pobrać.
     * @returns {Promise<Object>} Zwraca dane logów o podanym ID.
     */
    getOrderLogsByOrderId(id) {
        return axios.get(`${API_URL}/order/${id}`);
    }
}

export default new orderLogService();
